document.addEventListener('DOMContentLoaded', function() {
    if(document.querySelector("body").getAttribute("market-type") == "b2b") {
        var cuSymbol = document.querySelector(".fw-current-symbol").innerHTML;

        if(document.querySelector('.fw-b2b-price')) {

            const cards = document.querySelectorAll('.fw-b2b-price');
            var productHandles = [];
            cards.forEach(item => {
                productHandles.push(item.getAttribute("product-handle"));
            });

            console.log("productHandles", productHandles);

            const shopUrl = "finewines-aps.myshopify.com";
            const storefrontAccessToken = "572deeb3a166e5a302911ffaf1ed1bf4";
            const graphQLQuery = `
            {
                ${productHandles.map((handle, index) => `
                    product_${index}: product(handle: "${handle}") {
                    title
                    handle
                    variants(first: 10) {
                        edges {
                        node {
                            id
                            title
                            price {
                                amount
                                currencyCode
                            }
                        }
                        }
                    }
                    }
                `).join('\n')}
            }`;

            // console.log("graphQLQuery", graphQLQuery);

            fetch(`https://${shopUrl}/api/graphql`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Shopify-Storefront-Access-Token": storefrontAccessToken,
            },
            body: JSON.stringify({ query: graphQLQuery }),
            })
            .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
            })
            .then(data => {
                console.log("Storefront API Response:", data);
                for(var i = 0; i < productHandles.length; i ++) {
                    var dataProduct  = data["data"]["product_" + i];
                    var dataVariants = data["data"]["product_" + i]["variants"]["edges"];
                    const selCard = document.querySelector(".fw-b2b-price[product-handle='" + dataProduct.handle + "']");
                    const variantId = selCard.querySelector(".quantity-controls input").getAttribute("data-variant-id");
                    const card_vats = selCard.querySelector('.price-holder .price');
                    var b2bPrice = 0;
                    console.log("dataProduct.handle:", selCard);
                    // console.log("dataProduct:", dataProduct);
                    // console.log("dataProduct.handle:", dataProduct.handle);
                    // console.log("Variant ID:", variantId);
                    for(var j = 0; j < dataVariants.length; j ++) {
                        const var_id = dataVariants[j]["node"]["id"].split("gid://shopify/ProductVariant/")[1];
                        const var_price = dataVariants[j]["node"]["price"]["amount"];
                        console.log("Variant ID:", var_id);
                        console.log(" Price:", var_price);
                        if(variantId == var_id) {
                        b2bPrice = var_price * 0.8;
                        card_vats.textContent = parseInt(b2bPrice) + cuSymbol;
                        }
                    }
                }
            })
            .catch(error => {
            console.error("Error fetching from Storefront API:", error);
            });

        }
    }

});